<!-- 二级菜单 -->
<template>
  <div class="submenu">
    <h1 style="text-align: center;color:#686c6e"
        v-if="merge.length === 0 && tool.length === 0">
      暂无数据
    </h1>
    <div style="display:flex;width:1880px;flex-wrap: nowrap">
      <div class="table" v-if="merge.length !== 0 && this.global.model !== 2">
        <h3>学习计划</h3>
        <el-table
          :data="merge"
          height="500"
          :default-sort="{prop: 'state', order: 'ascending'}"
          align="center">
          <el-table-column
            type="index"
            :sortable="true"
            :sort-method="(a,b) => sortMethod(a ,b , 'state')"
            label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="150"
            label="具体业务">
            <template slot-scope="scope">
              {{ scope.row.specific_content == '无' ? '学习视频' : scope.row.specific_content }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="文件名">
            <template slot-scope="scope">
              <!--              <div v-if="scope.row.state == 1" style="color: #00b247"> {{ scope.row.file_name }}</div>-->
              <!--              <div v-else :style="scope.row.state ? 'color: red' : ''"> {{ scope.row.file_name }}</div>-->
              <div> {{ scope.row.file_name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="getcontent(scope.row)">查看 {{ scope.row.state == 2 ? '视频' : '书本' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table" v-if="video.length !== 0 && this.global.model === 2">
        <h3>视频</h3>
        <el-table
          :data="sortVideo"
          height="500"
          :default-sort="{prop: 'state', order: 'ascending'}"
          align="center">
          <el-table-column
            type="index"
            prop="state"
            :sortable="true"
            :sort-method="(a,b) => sortMethod(a ,b , 'state')"
            label="序号">
            <template slot-scope="scope">
              <div> {{ (scope.$index + 1) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="文件名">
            <template slot-scope="scope">
              <div v-if="scope.row.state == 1" style="color: #00b247"> {{ scope.row.file_name }}</div>
              <div v-else :style="scope.row.state ? 'color: red' : ''"> {{ scope.row.file_name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="100"
            label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="getVideo(scope.row)"
                         v-text="scope.row.state == 1 ? '已学习':'查看'"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table" v-if="tool.length !== 0">
        <h3>文件</h3>
        <el-table
          :data="tool"
          height="500"
          align="center"
        >
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="file_name"
            label="文件名">
          </el-table-column>
          <el-table-column
            width="100"
            label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="getTool(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      submenuList: [],
      video: [],
      tool: [],
      total: 0,
      page: 1,
      size: 6,
      videoReadList: []
    }
  },
  computed: {
    // 书本视频合并
    merge () {
      let data = this.submenuList
      let video = this.sortVideo
      let model = this.global.model
      if (model === 3) { // 法规
        video = []
      }
      let objdata = []
      for (let i in video) {
        // eslint-disable-next-line eqeqeq
        if (video[i].state == 2) {
          video[i]['specific_content'] = '无'
          objdata.push(video[i])
        }
      }
      let result = objdata.concat(data)
      return result
    },
    sortVideo () {
      let datas = this.videoReadList
      let data = this.video
      // 实现table 排序必读靠前
      for (let i in data) {
        data[i].state = 0 // 初始化
      }
      for (let i in data) {
        if (data[i].job != null) {
          let ARR = data[i].job
          for (let f in ARR) {
            // eslint-disable-next-line eqeqeq
            if (ARR[f] == this.global.station_id) { // 当前用户岗位id等于必看视频id
              data[i].state = 2
              break
            }
          }
        }
      }
      for (let s in datas) {
        for (let f in data) {
          // eslint-disable-next-line eqeqeq
          if (datas[s] == data[f].id) {
            data[f].state = 1 // 表示用户已播放该视频
          }
        }
      }
      // 排序 未看在顶部 已看在中间
      let result = []
      let result2 = []
      let result3 = []
      for (let i in data) {
        if (data[i].state === 2) {
          result.push(data[i])
        } else if (data[i].state === 1) {
          result2.push(data[i])
        } else {
          result3.push(data[i])
        }
      }
      result = result.concat(result2).concat(result3)

      return result
    },
    menuId: function () {
      return this.$route.query.data.id
    },
    menuName: function () {
      return this.$route.query.data.menu
    },
    mainId: function () {
      return this.$route.query.data.mainId
    },
    keyWord: function () {
      return this.$route.query.keyWord
    },
    folder: function () {
      if (this.mainId === 2) {
        return 'video'
      } else if (this.mainId === 7) {
        return 'tool'
      }
    }
  },
  watch: {
    keyWord: function (newVal, oldVal) {
      if (this.keyWord !== undefined && this.keyWord !== '') {
        let key = newVal
        this.getListByKeyWord(key)
      }
    }
  },
  methods: {
    sortMethod (obj1, obj2, column) {
      var at = obj1[column]
      var bt = obj2[column]
      if (at > bt) {
        return -1
      } else {
        return 1
      }
    },
    getVideo (data) {
      let src = {}
      src.path = this.global.videoUrl + data.menu_id + '/' + data.id + '/' + data.name
      src.id = data.id
      src.state = data.state
      this.$router.push({path: '/video', query: {src: src}})
    },
    getTool (data) {
      let src = this.global.toolUrl + data.menu_id + '/' + data.id + '/' + data.name
      window.location.href = src
    },
    // 进入路由获取数据
    firstGetSubmenuList () {
      this.videoReadList = this.global.videoReadList
      let type = this.$route.query.type
      type = parseInt(type)
      // 显示所有未读列表进入
      if (type) {
        this.submenuList = this.global.getUnreadByType(type)
        if (this.global.model !== 3) {
          this.getFolderList({menu_id: 200}, 'video')
        }
        return
      }
      // 通过关键词搜索进入
      let keyWord = this.$route.query.keyWord
      if (keyWord) {
        // 按关键字请求一遍, 按video和tool分别请求工具一遍
        this.getListByKeyWord(keyWord)
        return
      }
      // 通过菜单进来, 判断是要获取书本类还是视频工具类
      let mainId = this.mainId
      if (mainId !== 2 && mainId !== 7) {
        // 获取书本类
        this.getListByMenuId()
      } else {
        // 获取视频工具类
        let filter = {}
        filter.menu_id = this.menuId
        let folder = this.folder
        this.getFolderList(filter, folder)
        this.getListByMenuId()
      }
    },
    getListByKeyWord (keyWord) {
      let now = parseInt(new Date().getTime() / 1000)
      let info = this.global.user_info
      let filter = {}
      filter.job = info.station_id
      filter.begin = now
      filter.end = now
      filter.belong_ship = info.serve_ship
      filter.branch_id = info.branch_id
      filter.remove = 0
      filter.file_name = keyWord
      this.getFolderList(filter, 'video')
      this.getFolderList(filter, 'tool')
      this.getSubmenuList(filter)
    },
    getListByMenuId () {
      let menuId = this.menuId
      let mainId = this.mainId
      let filter = {}
      filter.menu_id = menuId
      filter.remove = 0
      let now = parseInt(new Date().getTime() / 1000)
      let info = this.global.user_info
      filter.job = info.station_id
      filter.begin = now
      filter.end = now
      filter.belong_ship = info.serve_ship
      filter.branch_id = info.branch_id
      // 查找的是基本业务类型还是法规
      if (mainId !== 6) {
        filter.type = 1
      } else {
        filter.type = 3
      }
      this.getSubmenuList(filter)
    },
    updateLearn () {
      let msg = {}
      msg.id = this.global.user_info.id
      msg.times = Math.round(new Date() / 1000)
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.updateLearnfn
      sendData.vm = this
      req.Post('user/updateLearn', sendData)
    },
    updateLearnfn (data) {
      if (data.err_code !== 0) {
      }
    },
    getcontent (data) {
      /*
*  记录当前时间
*  用于教师端 查看当前学员最后一次学习时间
* */
      this.updateLearn()
      if (data.state === 2) {
        this.getVideo(data)
        return
      }
      if (data.type === 2) {
        // 是考试类型
        this.$router.push({path: '/examination', query: {data: data}})
        return
      }
      // this.$parent.$parent.getUserData(this.global.token)
      this.$router.push({path: '/books', query: {data: data}})
    },
    changeState (index) {
      let state = this.showState[index].state
      this.showState[index].state = !state
    },
    // 获取视频和工具
    // filter: 筛选条件 folder 文件夹名 'video' 或 'tool'
    getFolderList (filter, folder) {
      let obj = {}
      obj.folder = folder
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getFolderListFn
      sendData.vm = this
      req.Post('fileMenuData/get_file', sendData)
    },
    getFolderListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }

      let folder = data.folder
      this[folder] = data.list
    },
    getSubmenuList (filter) {
      let obj = {}
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getSubmenuListFn
      sendData.vm = this
      req.Post('ship_train/post', sendData)
    },
    getSubmenuListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.submenuList = data.list
    }
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.firstGetSubmenuList()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    this.submenuList = []
    this.video = []
    this.tool = []
    next()
  }
}
</script>
<style scoped>
.submenu {
  width: 97.8%;
  height: 93%;
  padding: 20px;
}

.submenuList {
  width: 96%;
  height: 96%;
  background-color: #fff;
  padding: 5px 2% 5px 2%;
  display: flex;
  overflow: auto;
  /* flex-direction: column; */
  flex-wrap: wrap;
  align-content: flex-start;
}

.submenuList_row {
  width: 20%;
}

.submenuList_title {
  display: flex;
  justify-content: left;
  align-items: center;
  height: 40px;
  color: #00aaff;
}

.submenuList_children {
  height: 25px;
  display: flex;
  justify-content: left;
  align-items: center;
  width: 95%;
  margin-left: 5%;
  color: #ec3838;
  /* color: #00b247; */
}

.titleIcon {
  color: #00aaff;
  margin-right: 20px;
  cursor: pointer;
}

.childrenIcon {
  color: #00aaff;
  margin-right: 20px;
}

.readBtn {
  border: 0;
  background: #f0f8ff00;
  cursor: pointer;
  color: #00aaff;
  /* color: #ec3838; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
}

.read {
  color: #00b247;
}

.table {
  width: 30%;
  flex-grow: 1;
  text-align: center;
  /* margin:0 auto */
}
</style>



// WEBPACK FOOTER //
// src/components/submenu.vue